export enum DebtStatusesEnum {
  PROCESSING = 'PROCESSING',
  PAID = 'PAID',
  SUSPENDED = 'SUSPENDED',
}

export enum DebtSourceTypesEnum {
  INSPECTION_VIOLATIONS = 'INSPECTION_VIOLATIONS',
  INSPECTION_DAMAGES = 'INSPECTION_DAMAGES',
  PLAN_INSPECTION_DELAY = 'PLAN_INSPECTION_DELAY',
  EXTERNAL_PENALTY = 'EXTERNAL_PENALTY',
  BALANCE_CORRECTION = 'BALANCE_CORRECTION',
  TOLL_ROAD = 'TOLL_ROAD',
  REDEMPTION_PAYMENT = 'REDEMPTION_PAYMENT',
  OSAGO = 'OSAGO',
  TIRES = 'TIRES',
  AUTO_TRANSMISSION = 'AUTO_TRANSMISSION',
  GBO = 'GBO',
  SERVICE = 'SERVICE',
  OTHER_CHARGES = 'OTHER_CHARGES',
}

export enum EventAuditEnum {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  RESTORED = 'restored',
  BALANCE_TRANSFER = 'balance_transfer',
}

export enum TimezoneCode {
  KALININGRAD = 'Europe/Kaliningrad', // UTC+2
  MOSCOW = 'Europe/Moscow', // UTC+3
  SAMARA = 'Europe/Samara', // UTC+4
  YEKATERINBURG = 'Asia/Yekaterinburg', // UTC+5
  OMSK = 'Asia/Omsk', // UTC+6
  KRASNOYARSK = 'Asia/Krasnoyarsk', // UTC+7
  IRKUTSK = 'Asia/Irkutsk', // UTC+8
  YAKUTSK = 'Asia/Yakutsk', // UTC+9
  VLADIVOSTOK = 'Asia/Vladivostok', // UTC+10
  MAGADAN = 'Asia/Magadan', // UTC+11
  KAMCHATKA = 'Asia/Kamchatka', // UTC+12
}

export enum LocaleEnum {
  ru = 'ru',
  en = 'en',
  fr = 'fr',
}

export enum TaxiparkCountryEnum {
  RU = 'RU',
  CI = 'CI',
}
